module.exports = __webpack_public_path__ + "static/media/cordova.5cbd6586.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/cordova.png
// module id = 85
// module chunks = 0